import { Injectable, Type } from '@angular/core';
import { InputComponent } from '@app/modules/change-requests/interfaces/input-component.class';
import { DepartmentInputComponent } from '@change-requests/components';
import { CompensationTypeInputComponent } from '@change-requests/components/input-components/compensation-type-input.component';
import { EmploymentTypeInputComponent } from '@change-requests/components/input-components/employment-type-input.component';
import { EndDateInputComponent } from '@change-requests/components/input-components/end-date-input.component';
import { HoursPerWeekInputComponent } from '@change-requests/components/input-components/hours-per-week-input.component';
import { LocationInputComponent } from '@change-requests/components/input-components/location-input.component';
import { PositionInputComponent } from '@change-requests/components/input-components/position-input.component';
import { RateInputComponent } from '@change-requests/components/input-components/rate-input.component';
import { ReportsToInputComponent } from '@change-requests/components/input-components/reports-to-input.component';
import { StockOptionsInputComponent } from '@change-requests/components/input-components/stock-options-input.component';
import { VacationPayInputComponent } from '@change-requests/components/input-components/vacation-pay-input.component';

@Injectable()
export class InputComponentsService {
    private fields = {
        compensation_type: CompensationTypeInputComponent,
        department: DepartmentInputComponent,
        employment_type: EmploymentTypeInputComponent,
        end_date: EndDateInputComponent,
        hours_per_week: HoursPerWeekInputComponent,
        location: LocationInputComponent,
        position: PositionInputComponent,
        rate: RateInputComponent,
        reports_to: ReportsToInputComponent,
        stock_options: StockOptionsInputComponent,
        vacation_pay: VacationPayInputComponent,
    };

    getComponentClass(fieldKey: string): Type<InputComponent> {
        return this.fields[fieldKey];
    }
}
